<template>
  <div class="container">
    <div class="title">
      <p class="words">订单数(个)</p>
    </div>
    <div class="val-pot">订单数：{{carouselVal}}个</div>
    <div id="chart6" ref="main6" style="width: 100%; height: 160px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea6: null,
      xData:[],
      yData:[],
      carouselVal:0,
      timerId: null, //定时器的标识
    };
  },
  props:{
    level:'',
    regionId:''
  },
  destroyed() {
    clearInterval(this.timerId);
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.echartArea6 = this.$echarts.init(this.$refs.main6);
      this.getoption8Data();
    },
    // 组件8数据源 充电订单个数
    getoption8Data() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getOrderTotalMonth"),
        method: "get",
        params: this.$http.adornParams({
          findType: 1,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'充电订单个数')
        if (data.code == 0) {
          this.xData = data.data.keys;
          this.yData = data.data.values1;
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      var XData = this.xData;
      var YData = this.yData
      const option = {
        grid: {
          left: "1%",
          right: "1%",
          bottom: "10%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: {
          type: "category",
          gridIndex: 0,
          data: XData,
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: 10,
          },
        },
        yAxis: {
          type: "value",
          gridIndex: 0,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: function(value){
            if(value.max<=20000){
              return 20000
            }else if(value.max >20000 && value.max <=50000){
              return 50000
            }else{
              return 100000
            }
          },
          xisLabel: {
            color: "rgb(170,170,170)",
            formatter: "{value} ",
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              color: "rgba(135,140,147,0.8)",
            },
          },
          axisLabel: {
            formatter:function(value){
              value = value.toString();
              if(value>=100000){
                return (value.substring(0,2)/10)+'万'
              }else if(value>=80000){
                return (value.substring(0,2)/10)+'万'
              }else if(value>=40000){
                return (value.substring(0,2)/10)+'万'
              }else if(value>=20000){
                return (value.substring(0,2)/10)+'万'
              }else if(value>=10000){ 
                return (value.substring(0,2)/10)+'万'
              }else if(value>=5000){ 
                return (value.substring(0,1)/10)+'万'
              }else{
                return 0
              }
            },
            fontSize: 10,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "合格率",
            type: "bar",
            barWidth: "30%",
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#30BC74",
                },
                {
                  offset: 1,
                  color: "#AEF2D6",
                },
              ]),
              barBorderRadius: [10, 10, 0, 0],
            },
            emphasis: {
              itemStyle: {
                color: "#F7B500",
              },
              label: {
                show: false,
              },
            },
            data: YData,
            zlevel: 11,
          },
        ],
      };

      this.echartArea6.setOption(option);
      let _t = -1;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        var dataLen = option.series[0].data.length;
        this.echartArea6.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: _t,
        });
        _t = (_t + 1) % dataLen;
        this.echartArea6.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: _t,
        });
        this.carouselVal = option.series[0].data[_t]
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;
  position: relative;
  .val-pot{
    position: absolute;
    right: 20px;
    top: 12px;
    font-size: 12px;
  }
}
.title {
  width: 140px;
  height: 28px;
  line-height: 28px;
  background-image: url("../../assets/title-bg.png");
  background-size: 100% 100%;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #00ecfc;
  position: relative;
  .words {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 280px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/option8.vue